import { DiscoveryStatusByProduct } from '@interfaces/discoveryStatus';
import { fetcher } from '@utils/fetcher';

export const findDiscoveryStatus = async (
  ids: number[],
): Promise<DiscoveryStatusByProduct> =>
  fetcher(`/api/products/discoveryStatus?ids=${ids.join(',')}`, {
    method: 'GET',
  });
